import React from "react";
import { Animation } from "elements";
import darkAnimation from "assets/animations/Lens-Empty-Dark.json";
import lightAnimation from "assets/animations/Lens-Empty-Light.json";

const NoResultsIndicatorAnimation: React.FC<{
  className?: string;
  title?: string;
  titleStyle?: string;
}> = ({ className, title, titleStyle, children }) => {
  const cssClasses = ["no-results-indicator", className]
    .filter(c => !!c)
    .join(" ");

  return (
    <div className={cssClasses} id="no-results-animation">
      <Animation
        animation={{
          light: lightAnimation,
          dark: darkAnimation
        }}
        title={title}
        titleStyle={titleStyle ?? ""}
      />
      {children}
    </div>
  );
};

export default NoResultsIndicatorAnimation;
